export const AnswerSeparator = " - ";
export const EmptyAnswer = "-";
